import { useState } from 'react'
import Pagination from '@bit/atd.web.pagination'

const usePagination = (defaultPage = 1) => {
  const [currentPage, setCurrentPage] = useState(defaultPage)
  const [prevPage, setPrevPage] = useState()
  const paginationProps = {
    currentPage,
    prevPage,
    setCurrentPage,
    defaultPage: currentPage,
    onChange: (_: any, page: number) => {
      // @ts-ignore
      setPrevPage(currentPage)
      setCurrentPage(page)
    },
  }

  return {
    Pagination,
    paginationProps,
  }
}

export default usePagination
